import React from 'react';
import { withStyles } from '@material-ui/core';

import NoBMLoyalty from '@componentsV2/NoBMLoyalty';

import WithHeader from '../../../../components/layouts/WithHeader';
import styles from './style';

const LoyaltyPage = ({ classes }) => {
  return (
    <WithHeader headerTitle="Leverandører" noPadding>
      <div className={classes.page}>
        <NoBMLoyalty />
      </div>
    </WithHeader>
  );
};

export default withStyles(styles)(LoyaltyPage);
